// extracted by mini-css-extract-plugin
export default {"toolbar":"ToolbarStyles-modules__toolbar__JUPa3"};